import React, {useState, useEffect} from 'react'
import {H2, Ul, Li} from 'gatsby-theme-carbon/src/components/markdown';
import { AnchorLinks, InlineNotification } from 'gatsby-theme-carbon';
import { Column, Row, TextInput, FormGroup, FileUploaderDropContainer, Button, Modal } from 'carbon-components-react';
import { Location32, Enterprise32, Launch24 } from "@carbon/icons-react";
import {Link} from 'gatsby';
import {handleEmail} from '../util'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import recaptchaSubmit from '../util/recaptchaSubmit'

const JobBody = ({job_data, isPreview = true, objectType}) => {
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [applicationSent, setApplicationSent] = useState(false)
    const [coverLetter, setCoverLetter] = useState(null)
    const [resume, setResume] = useState(null) 
    const [fullName, setFullName] = useState(null)
    const [email, setEmail] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null)
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [modalTitle, setModalTitle] = useState('')
    const [docs, setDocs] = useState([])

    useEffect(() => {
      if( job_data.method && job_data.method[0] === 'board' && objectType !== 'localstorage'&& job_data.method[1]){
        setDocs(job_data.method[1])
      }
    }, [])

    useEffect(() => {
      setModalTitle(applicationSent ? 'Application sent' : 'Please enter your information below:');
    }, [applicationSent])

    const handleFile = (file, name) => {
      var reader = new FileReader();
      reader.onloadstart = function() {
        setIsLoading(true)
      }
      reader.onload = function(readerEvent) {
        let encodedBase64 = readerEvent.target.result;
        // data:application/pdf;base64,
        if (name === 'cover-letter') {
          setCoverLetter({ type: file.type, name: file.name, content: encodedBase64.slice(file.type.length + 13) }) 
        } else {
          setResume({ type: file.type, name: file.name, content: encodedBase64.slice(file.type.length + 13) }) 
        }
        // old way i was attaching files to an array and storing as state
        //setAttachments(attachments.concat({ type: file.type, name: file.name, content: encodedBase64.slice(file.type.length + 13) }))
        //document.querySelector('#display-pdf').innerHTML = `<object data="${readerEvent.target.result}" type="application/pdf" width="400px" height="200px"></object>`;
        // disableApplyButton(false)
        setIsLoading(false)
      }
      reader.readAsDataURL(file) 
    }

    const onChangeAttachment = (e) => {
      const file = e.target.files[0]
      handleFile(file, e.target.name)
    }

    const removeFile = (e) => {
      if (e.target.id === 'remove-resume') {
        setResume(null)
      } else if (e.target.id === 'remove-cover-letter') {
        setCoverLetter(null)
      }
    }

    const handleSubmit = async () => {
      setIsLoading(true)
      try {
        const valid = await recaptchaSubmit(executeRecaptcha)
        if (!valid) throw "Failed recaptcha"
        if (!fullName) {
          setErrorMessage('Please provide a name for the application') 
        } else if (!email) {
          setErrorMessage('Please provide an email for the application')
        } else if (errorMessage) {
          setErrorMessage(null) 
        }
        if (!applicationSent && fullName && email) {
          let attachments = []
          if (resume && resume.name) attachments.push(resume)
          if (coverLetter && coverLetter.name) attachments.push(coverLetter)
          if(attachments.length !== docs.length){
            setErrorMessage('Please provide all the required documents for the application')
          }else{
            handleEmail({applicantName: fullName, email: email, attachments: attachments}, job_data)
            setApplicationSent(true)
            setCoverLetter(null)
            setResume(null)
          }
        }
        setIsLoading(false)
      } catch (err) {
        console.log(err)
        setIsLoading(false)
      }
      return applicationSent
    }

    return (
        <>
            <div className="job-subhead">
                {job_data.field_company_name && <H2><Enterprise32 /> {job_data.field_company_name}</H2>}
                <small><Location32 /> {job_data.address}</small>
                {isPreview && !job_data.is_expired && objectType !== 'localstorage' && <InlineNotification className="inline-notification" kind="info"><strong>This is a preview.</strong> Your job listing will be published shortly. </InlineNotification>}
                {objectType === 'localstorage' && <InlineNotification className="inline-notification" kind="info"><strong>This is a preview.</strong> </InlineNotification>}
                {isPreview && job_data.is_expired && <InlineNotification className="inline-notification" kind="error"><strong>Expired.</strong> This job listing has expired. </InlineNotification>}
                {!job_data.method && <InlineNotification className="inline-notification" kind="error">No application method provided</InlineNotification>}
                {/* <InlineNotification kind="info">This job offer will expire in 12 days</InlineNotification> */}
            </div>
            <Row className="job-overview">
                <Column lg={6} >
                    <Ul>
                        {job_data.salary && <Li key="sal">Salary: <strong>{job_data.salary}</strong></Li>}
                        {job_data.education && <Li  key="edu">Education: <strong>{job_data.education.name}</strong></Li>}
                        {job_data.bilingual && <Li  key="bily">Bilingual: <strong>{job_data.bilingual.name}</strong></Li>}
                        {job_data.experience && <Li  key="exp">Experience: <strong>{job_data.experience}</strong></Li>}
                        {job_data.position && <Li  key="pos">Position: <strong>{job_data.position}</strong></Li>}
                        {job_data.category_links && <Li  key="cat">{job_data.category_links.length === 1 ? 'Job Category' : 'Job Categories'}: {job_data.category_links}</Li>}
                        <Li  key="dte">Posted: <strong>{job_data.posted}</strong></Li>
                    </Ul>
                    <>
                      <Modal 
                          className="apply-modal"
                          id="ApplyOnSiteModal"
                          key="modal" 
                          size="sm" 
                          open={open} 
                          onRequestClose={() => {setOpen(false)}} 
                          modalLabel={`Job title: ${job_data.title}, ${job_data.field_company_name}`} 
                          modalHeading={modalTitle} 
                          primaryButtonText="Apply now"
                          secondaryButtonText="Cancel"
                          passiveModal={applicationSent}
                          onRequestSubmit={(e) => {
                              handleSubmit();
                          }}
                          primaryButtonDisabled={isLoading}
                          onRequestClose={(e) => {
                              if(isLoading) {
                                  e.preventDefault();
                              }else{
                                  setOpen(false);
                                  setErrorMessage(null);
                              }
                          }}
                      >
                        <div className="apply-form">
                            {applicationSent && <InlineNotification className="inline-notification" kind="success">
                            <p><strong>Thank you for your submission!</strong></p>
                            <p>The recruitment contact offering this job opportunity has been sent an email containing your application materials.</p>
                            <p>If you have any questions regarding your submission, please follow up directly with the recruitment contact.</p>
                            <p>Best of luck in your job search!</p>
                            <p><Link to="/job-search">Browse more jobs</Link></p>
                            </InlineNotification>}
                            {errorMessage && 
                              <InlineNotification className="inline-notification" kind="error">
                                <p>{errorMessage}</p>
                              </InlineNotification>
                            }
                            {!applicationSent && <>
                            <TextInput
                                id="apply-full-name"
                                labelText="Full Name:"
                                value={fullName}
                                onChange={(e) => { setFullName(e.target.value) }}
                            />
                            <TextInput
                                id="apply-email"
                                labelText="Email:"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value) }}
                            />
                            {docs.map((doc_label) => {
                                return <FormGroup key={doc_label} legendText={`${doc_label}:`}>
                                <p className='bx--label-description'>
                                    Only one .pdf file 2MB max file size
                                </p>
                                <FileUploaderDropContainer
                                    accept={[
                                    '.pdf'
                                    ]}
                                    labelText={
                                      doc_label === 'Cover letter' && coverLetter && coverLetter.name ? 
                                        coverLetter.name : doc_label === 'Resume' && resume && resume.name ?
                                        resume.name : `Click to upload your ${doc_label.toLowerCase()}`
                                    }
                                    tabIndex={0}
                                    onChange={(e) => { onChangeAttachment(e) }}
                                    name={doc_label.toLowerCase().trim().replace(' ', '-')}
                                />
                                {(doc_label === 'Cover letter' && coverLetter && coverLetter.name) || (doc_label === 'Resume' && resume && resume.name) ?
                                  (<span>
                                    <Button onClick={removeFile} id={`remove-${doc_label.trim().toLowerCase().replace(' ', '-')}`}>Remove {doc_label.trim().toLowerCase()}</Button>
                                  </span>) : (<></>)
                                }
                                </FormGroup>
                            })}
                            </>}
                        </div>
                    </Modal>
                    {job_data.method && job_data.method[0] === 'external' && <a target="_blank" className="apply-link" href={job_data.method[1]} rel="noopener noreferrer" id="ApplyExternalURL"><strong>Apply on external website</strong> <Launch24 /></a>}
                    {job_data.method && job_data.method[0] === 'board' && objectType !== 'localstorage' && <Button onClick={(e) => {setOpen(true)}} id="ApplyOnSite">Apply now</Button>}
                    {job_data.method && job_data.method[0] === 'board' && objectType === 'localstorage' && <Button>Apply now</Button>}
                  </>
                </Column>
                {job_data.anchors && <Column lg={6} ><AnchorLinks>{job_data.anchors}</AnchorLinks></Column>}
            </Row>
            <div className="job-narrative">
                {job_data.content}
            </div>
        </>
    )
}



export default JobBody;
